import { Component as ReactComponent } from "react";

import { BTLayout } from "commonComponents/btWrappers/BTLayout/BTLayout";
import { BTListLayout } from "commonComponents/btWrappers/BTListLayout/BTListLayout";
import { BTTitle } from "commonComponents/btWrappers/BTTitle/BTTitle";

import "./SingleBuilderRequired.less";

export interface ISingleBuilderRequired {
    allBuildersSelected: boolean;
    canGetBuilderFromSelectedJob?: boolean;
    jobIds?: number[];
}

export const withSingleBuilderRequired =
    (listTitle?: string) =>
    <P extends object>(Component: React.ComponentType<P & ISingleBuilderRequired>) =>
        class WithSingleBuilderRequired extends ReactComponent<P & ISingleBuilderRequired> {
            render() {
                const { allBuildersSelected, canGetBuilderFromSelectedJob, jobIds } = this.props;
                const hasValidJobSelected =
                    canGetBuilderFromSelectedJob && jobIds?.length === 1 && jobIds[0] > 0;

                if (allBuildersSelected && !hasValidJobSelected) {
                    const innerComponent = (
                        <div className="SingleBuilderRequiredContainer">
                            <BTTitle className="SingleBuilderRequiredTitle" level={1}>
                                No Builder Selected
                            </BTTitle>
                        </div>
                    );
                    return listTitle ? (
                        <BTListLayout title={listTitle}>{innerComponent}</BTListLayout>
                    ) : (
                        <BTLayout>{innerComponent}</BTLayout>
                    );
                }
                return <Component {...this.props} />;
            }
        };
